import {
    ComponentStoreV2Factory,
} from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { ServiceTypeObject } from '@it2go/types';

@Injectable()
export class ServiceTypeRegionUpsertDialogStore extends ComponentStoreV2Factory {

    public serviceType = computed<ServiceTypeObject>(() => {
        return this.globalGlobalStore.serviceTypeStore.serviceType() as any;
    });

}
